import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";

// Lazy load below-the-fold components for better TTI
const About = lazy(() => import("@/components/About"));
const Services = lazy(() => import("@/components/Services"));
const Reviews = lazy(() => import("@/components/Reviews"));
const Gallery = lazy(() => import("@/components/Gallery"));
const Estimate = lazy(() => import("@/components/Estimate"));
const Contact = lazy(() => import("@/components/Contact"));
const Footer = lazy(() => import("@/components/Footer"));
const LiveChat = lazy(() => import("@/components/LiveChat").then(m => ({ default: m.LiveChat })));

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main id="main-content" role="main">
        <Hero />
        <Suspense fallback={null}>
          <About />
          <Services />
          <Reviews />
          <Gallery />
          <Estimate />
          <Contact />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
        <LiveChat />
      </Suspense>
    </div>
  );
};

export default Index;
